import { render, staticRenderFns } from "./YoutubeWhitelist.vue?vue&type=template&id=84030394"
import script from "./YoutubeWhitelist.vue?vue&type=script&lang=js"
export * from "./YoutubeWhitelist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports